import { SxProps, keyframes } from "@mui/material";

export const getCellStyles = (
  isSelected: boolean,
  width: number,
  isSelectedDepartureAndReturnBefore: boolean,
  isSelectedReturnAndDepartureAfter: boolean,
  isNavigation: boolean = false,
) => {
  let styles: SxProps = {
    display: "flex",
    position: "absolute",
    width: `${width}%`,
    border: `1px solid white`,
    transition: `background 300ms`,
    textAlign: "left",
    fontSize: "initial",
    color: "grey.700",
  };

  if (isSelected) {
    styles.backgroundColor = "primary.main";
    styles.color = "white.main";
  } else if (
    isSelectedDepartureAndReturnBefore ||
    isSelectedReturnAndDepartureAfter
  ) {
    styles.backgroundColor = "grey.200";
  } else if (isNavigation) {
    styles.backgroundColor = "grey.100";
  } else {
    styles.color = "grey.700";
  }
  return styles;
};

export const getCellColor = (
  isSelected: boolean,
  price: number,
  maxMin: { max: number; min: number },
) => {
  if (isSelected)
    return {
      color: "white.main",
    };
  else if (price === maxMin.max && price === maxMin.min)
    return { color: "grey.700" };
  else if (price === maxMin.min) return { color: "success.main" };
  return { color: "grey.700" };
};

export const fadeIn = keyframes`
from {
  opacity: 0;
}
to {
  opacity: 1;
}
`;

export const sxStyles: { [key: string]: SxProps } = {
  button: {
    flexDirection: "column",
    fontWeight: "initial",
    justifyContent: "space-between",
    alignItems: "start",
    animationFillMode: "forwards",
  },
  desktopButton: {
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    gap: "4.5px",
    transition: `background 300ms`,
  },
  desktopButtonPrice: {
    display: "flex",
    gap: 0.5,
    alignItems: "baseline",
  },
  desktopButtonRow: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    gap: 1.25,
  },
  selectedItinerary: {
    border: "2px solid",
    borderColor: "primary.main",
    zIndex: 2,
  },
  infoIcon: {
    position: "absolute",
    top: 4,
    right: 4,
    width: "auto",
    height: 16,
  },
  // shared calendar styles
  container: {
    overflow: "hidden",
    height: { xs: "100vw", md: "538px" },
    minHeight: { xs: "300px", md: "initial" },
    maxHeight: { xs: "500px", md: "initial" },
    position: "relative",
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    boxShadow: { sm: 1 },
    px: { xs: 0 },
    pl: { xs: 0, sm: 2, md: 0 },
    pb: { sm: 2, md: 0 },
    bgcolor: "grey.100",
  },
  greyBox: {
    position: "relative",
  },
  smallBox: {
    position: "absolute",
    left: 0,
    bottom: 0,
    borderLeft: `1px solid white`,
    borderBottom: `1px solid white`,
  },
  matrix: { position: "relative", overflow: "hidden" },
  wrapper: {
    position: "absolute",
    overflow: "visible",
    height: "100%",
    width: "100%",
    transition: "transform 300ms ease-in-out",
  },
  calendar: {
    my: { xs: 2, sm: 3, md: 2 },
    mx: { xs: 0, sm: 3 },
    ml: { xs: -2, sm: 0, md: 0 },
    width: {
      xs: "calc(100% + 32px)",
      sm: "100%",
    },
  },
};
